import React from "react";
import moment from "moment";
import { Typography, Stack } from "@mui/material";

/**
 * Extract plain text from a Draft.js JSON string.
 * Falls back to returning the original string if it's not valid Draft.js JSON.
 */
export const extractPlainText = (text) => {
  if (!text) return "";
  try {
    const parsed = JSON.parse(text);
    if (parsed && Array.isArray(parsed.blocks)) {
      return parsed.blocks.map((b) => b.text).join("\n");
    }
    return text;
  } catch {
    return text;
  }
};

/**
 * Check if content is Draft.js JSON (has "blocks" array).
 */
export const isDraftJsContent = (text) => {
  if (!text) return false;
  try {
    const parsed = JSON.parse(text);
    return parsed && Array.isArray(parsed.blocks);
  } catch {
    return false;
  }
};

export const FormatTitle = ({ date, authorName }) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography variant="body2" fontWeight={600}>
        {authorName || "Unknown"}
      </Typography>
      {date && (
        <Typography variant="caption" color="text.secondary">
          {moment(date).fromNow()} &middot;{" "}
          {moment(date).format("DD MMM YYYY hh:mm A")}
        </Typography>
      )}
    </Stack>
  );
};
